import { TargetCatalogEntryInfo } from 'ais-facade-api/api';
import moment from 'moment';
import { Row } from 'react-table';

import { Icon, VesselActionCell, VesselIcon } from 'app/components';

import { CountryFlag } from 'CountryFlag/CountryFlag';

import { Link } from 'react-router-dom';
import i18n from 'resources/i18n';

import styles from './VesselsPage.module.scss';
import { useFormatMoment } from 'app/hooks/useFormatMoment';
import clsx from 'clsx';

export const columns = [
  {
    Header: <Icon name="s-ais" size="20px" color="#fff" />,
    width: 34,
    minWidth: 34,
    maxWidth: 34,
    accessor: 'type',
    Cell: ({ row: { original: vessel } }: { row: Row<TargetCatalogEntryInfo> }) => {
      return (
        <div className={styles.center_icon_cell}>
          <VesselIcon vessel={vessel} />
        </div>
      );
    },
  },
  {
    Header: 'MMSI',
    accessor: 'mmsi',
    cellClassName: `${styles.link}`,
    Cell: ({ row: { original: vessel } }: { row: Row<TargetCatalogEntryInfo> }) =>
      typeof vessel.mmsi === 'number' ? (
        <Link to={`/vessels/${vessel.mmsi}`} className={styles.link}>
          {vessel.mmsi}
        </Link>
      ) : (
        <>&mdash;</>
      ),
    canSort: true,
    sortBy: 'MMSI',
  },
  {
    Header: 'Name',
    accessor: 'staticData?.name',
    Cell: ({ row: { original: vessel } }: { row: Row<TargetCatalogEntryInfo> }) => (
      <>
        {typeof vessel?.registryData?.name === 'string' ? (
          vessel.registryData.name
        ) : typeof vessel.staticData?.name === 'string' ? (
          vessel.staticData.name
        ) : (
          <>&mdash;</>
        )}
      </>
    ),
    canSort: true,
    sortBy: 'NAME',
  },
  {
    Header: 'IMO',
    accessor: 'staticData?.imo',
    Cell: ({ row: { original: vessel } }: { row: Row<TargetCatalogEntryInfo> }) => (
      <>
        {typeof vessel?.registryData?.imo === 'number' ? (
          vessel.registryData.imo
        ) : typeof vessel.staticData?.imo === 'number' ? (
          vessel.staticData.imo
        ) : (
          <>&mdash;</>
        )}
      </>
    ),
    canSort: true,
    sortBy: 'IMO',
  },
  {
    Header: 'Flag',
    Cell: ({ row: { original: vessel } }: { row: Row<TargetCatalogEntryInfo> }) => (
      <>
        {vessel?.meta?.countryName ? (
          <>
            {vessel.meta.countryCode && <CountryFlag countryCode={vessel.meta.countryCode.toLowerCase()} />}
            {vessel.meta.countryName} ({vessel.meta.countryCode})
          </>
        ) : (
          <>&mdash;</>
        )}
      </>
    ),
  },
  {
    Header: <Icon name="catalog-fleet" size="16px" />,
    accessor: 'belongsToFleet',
    Cell: ({ row: { original: vessel } }: { row: Row<TargetCatalogEntryInfo> }) => (
      <>
        {vessel.belongsToFleet ? (
          <div className={styles.center_icon_cell}>
            <Icon name="catalog-fleet" color="var(--default-primary)" size="16px" />
          </div>
        ) : (
          <></>
        )}
      </>
    ),
  },
  {
    Header: 'Type',
    Cell: ({ row: { original: vessel } }: { row: Row<TargetCatalogEntryInfo> }) => (
      <>{vessel.meta && vessel.meta.typeGroup ? vessel.meta.typeGroup : <>&mdash;</>}</>
    ),
  },
  {
    Header: 'DeadWeight',
    accessor: 'deadWeight',
    Cell: ({ row: { original: vessel } }: { row: Row<TargetCatalogEntryInfo> }) => (
      <>{vessel.registryData?.dwt ? `${vessel.registryData.dwt} ${i18n.t('WeightUnit')}` : <>&mdash;</>}</>
    ),
  },
  {
    Header: 'IceClass',
    accessor: 'iceClass',
    Cell: ({ row: { original: vessel } }: { row: Row<TargetCatalogEntryInfo> }) => (
      <>{vessel.registryData?.iceClass ? vessel.registryData.iceClass : <>&mdash;</>}</>
    ),
  },
  {
    Header: 'CreationYear',
    accessor: 'creationYear',
    Cell: ({ row: { original: vessel } }: { row: Row<TargetCatalogEntryInfo> }) => (
      <>{vessel?.registryData?.constructionDate ? new Date(vessel.registryData.constructionDate).getFullYear() : <>&mdash;</>}</>
    ),
  },
  {
    Header: 'Destination',
    Cell: ({ row: { original: vessel } }: { row: Row<TargetCatalogEntryInfo> }) => (
      <>{vessel.voyage?.destination ? vessel.voyage.destination : <>&mdash;</>}</>
    ),
  },
  {
    Header: 'DataObtained',
    Cell: ({ row: { original: vessel } }: { row: Row<TargetCatalogEntryInfo> }) => {
      const formatMoment = useFormatMoment();
      return <>{vessel.t ? formatMoment(moment(vessel.t)) : <>&mdash;</>}</>;
    },

    canSort: true,
    sortBy: 'LUT',
  },
  {
    Header: <Icon name="more-icon" width="13px" height="3px" />,
    accessor: 'actionCell',
    width: 34,
    minWidth: 34,
    maxWidth: 34,
    disableSortBy: true,
    Cell: ({ row: { original: vessel } }: { row: Row<TargetCatalogEntryInfo> }) => (
      <div className={clsx(styles.center_icon_cell, styles.action_cell)}>
        <VesselActionCell vessel={vessel} />
      </div>
    ),
  },
];
